import { PageHero } from "@/components/PageHero";
import { ShieldCheck, Car, MapTrifold, Clock } from "@phosphor-icons/react";

const STEPS = [
  {
    icon: ShieldCheck,
    title: "Get a Security Pass",
    body: "Ask your host to pre-approve your visit on the MyGate app, or stop by the gate-security desk and we'll buzz them.",
  },
  {
    icon: Car,
    title: "Parking",
    body: "Visitor parking is on Level B1, right after the security barrier. Spaces marked yellow are reserved for guests.",
  },
  {
    icon: MapTrifold,
    title: "Navigating Inside",
    body: "Towers are labelled T1 — T5 (anti-clockwise from the main gate). Internal signage will guide you to lifts and amenities.",
  },
  {
    icon: Clock,
    title: "Visiting Hours",
    body: "Guests are welcome 7:00 AM — 10:00 PM. For overnight stays, your host must inform the management office.",
  },
];

const Visitors = () => (
  <div data-testid="visitors-page">
    <PageHero
      overline="For Visitors"
      title={
        <>
          Welcome to
          <span className="italic text-brand-gold"> Exente.</span>
        </>
      }
      lead="Whether you're visiting family or attending an event, here's everything you need to know before you arrive."
      image="https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.title}
              data-testid={`visitor-step-${i}`}
              className="p-10 rounded-2xl border border-brand-sage bg-brand-sage/30 hover:bg-brand-ivory transition-colors"
            >
              <Icon size={36} weight="light" className="text-brand-forest" />
              <h3 className="font-display text-3xl text-brand-forest mt-6">{s.title}</h3>
              <p className="text-brand-mute mt-3 leading-relaxed">{s.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  </div>
);

export default Visitors;
